<header>
  <h1>App Notifications</h1>

  <button
    mat-button
    type="button"
    class="newButton"
    (click)="newNotification()"
    >
    Send Notification
  </button>
</header>

@if (loading) {
  <mat-card class="loading">
    <mat-card-content class="loading">
      @if (loading) {
        <mat-icon class="loading">autorenew</mat-icon>
      }
      Loading&hellip;
    </mat-card-content>
  </mat-card>
}
@if (!loading) {
  <section>
    <table
      mat-table
      [dataSource]="notifications"
      aria-describedby="Notification Table"
      >
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let row">{{row.date }}</td>
      </ng-container>
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let row">{{row.title }}</td>
      </ng-container>
      <ng-container matColumnDef="text">
        <th mat-header-cell *matHeaderCellDef>Text</th>
        <td mat-cell *matCellDef="let row">{{row.text }}</td>
      </ng-container>
      <ng-container matColumnDef="image">
        <th mat-header-cell *matHeaderCellDef>Image</th>
        <td mat-cell *matCellDef="let row">
          @if (row.image_url) {
            <a [href]="row.image_url" target="_blank"
              >Image</a
              >
            }
            @if (!row.image_url) {
              <p>No image set</p>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="url">
          <th mat-header-cell *matHeaderCellDef>Listing Url</th>
          <td mat-cell *matCellDef="let row">
            @if (row.url) {
              <a
                [href]="row.url"
                matTooltip="View page"
                target="_blank"
                class="url-link"
                >
                <p>Visit Link</p>
                <mat-icon class="icon">open_in_new</mat-icon>
              </a>
            }
            @if (!row.url) {
              <p>No url</p>
            }
          </td>
        </ng-container>
      </table>
      <mat-paginator
        (page)="DataSource.loadWithPageEvent($event)"
        [length]="PageEvent?.length"
        [pageIndex]="PageEvent?.pageIndex"
        [pageSize]="PageEvent?.pageSize"
      ></mat-paginator>
    </section>
  }
